import TokenOrNft from './TokenOrNft'

export default TokenOrNft
